var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[
    `button button--${_vm.appearance}`,
    _vm.small && 'button--small',
    _vm.fullWidth && 'button--block',
    _vm.loading && !_vm.icon && 'button--loading',
    `${_vm.iconClassName} ${_vm.customClass}`,
    _vm.disabled && 'button--disabled',
  ],attrs:{"role":"button"},on:{"click":function($event){return _vm.onButtonClick($event)}}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon)?_c('icon',{attrs:{"class-name":"button__icon","name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }